import { addRecord, getRecordById, updateRecord } from "../../../localDB";
import { activityClassification, planWorksheetStatusMapping } from "../../../visualizations/visualizations";

export async function transformWorksheets(rawWorksheets) {
    return Promise.all(
        rawWorksheets.map(async (worksheet) => {
            const transformed = {
                ID: worksheet?.id,
                EmployeeID: worksheet?.employee?.id,
                EmployeeName: worksheet?.employee?.name,
                PlanNumber: worksheet?.planNumber,
                Cycle: {
                    ID: worksheet?.cycle?.id,
                    Code: worksheet?.cycle?.code,
                    Description: worksheet?.cycle?.description,
                    StartDate: worksheet?.cycle?.start,
                    EndDate: worksheet?.cycle?.end
                },
                Statistics: worksheet?.statistics,
                Status: planWorksheetStatusMapping[worksheet?.status],
                Days: worksheet?.days,
            };

            const existing = await getRecordById("Worksheets", transformed.ID);

            if (existing) {
                await updateRecord("Worksheets", {
                    ...existing,
                    EmployeeID: transformed.EmployeeID,
                    Statistics: transformed.Statistics,
                    Status: transformed.Status
                });
            } else {
                await addRecord("Worksheets", transformed);
            }

            return transformed;
        })
    );
}

export async function transformPlanningAccount(rawPlanningAccount) {
    return rawPlanningAccount.map(account => {
        return {
            ID: account?.id,
            Code: account?.code,
            Name: account?.name,
            LastVisited: account?.lastVisited,
            SessionID: account?.sessionID,
            ReasonID: account?.reasonID,
            Status: 1
        };
    });
}

export async function transformActivities(rawActivities) {
    return rawActivities.map(act => {
        return {
            ID: act?.id,
            Description: act?.description,
            Classification: activityClassification[act?.classification]
        };
    });
}

export async function transformEvents(rawEvents) {
    return rawEvents.map(event => {
        return {
            ID: event?.id,
            Description: event?.description,
            Date: event?.eventDate
        };
    });
}

export async function transformLeaveTypes(rawLeaveTypes) {
    return rawLeaveTypes.map(leave => {
        return {
            ID: leave?.id,
            Code: leave?.code,
            Name: leave?.name
        };
    });
}

export async function transformRejectWorkplanReasons(rawRejectWorkplanReasons){
    return rawRejectWorkplanReasons.map(reason => {
        return {
            ID: reason.id,
            Code: reason.code,
            Description: reason.description
        }
    });
}